import { useAppSelector } from "../../../../../../redux/hooks";
import { getIcon } from "../../../../../../utils/get-icon";
import { useSettings } from "../../context";
import { useTimelineContext } from "../../remotion-timeline/context/use-timeline-context";
import { CloseButton } from "./styled";

interface SelectableProps {
  id: string;
  selected: boolean;
  children: React.ReactNode;
}

const Selectable = ({ id, selected, children }: SelectableProps) => {
  const { deleteItem } = useTimelineContext();
  const { getSelectedItemSettings } = useSettings();
  const currentSettings = getSelectedItemSettings();
  const video = useAppSelector((state) => state.transcript.data);

  const buttonSize = video.details.width * 0.07;
  const fontSize = buttonSize * 0.5;
  const leftPosition = buttonSize * -0.35;
  const topPosition = buttonSize * -0.45;

  const clickDelete = () => {
    deleteItem(id);
  };

  return (
    <div
      style={{
        cursor: "move",
        outline: selected ? "4px solid white" : "none",
        transform: "none",
        touchAction: "none",
        position: "absolute",
        width: `${currentSettings.size.width}px`,
        height: `${currentSettings.size.height}px`,
      }}
    >
      {selected && (
        <CloseButton
          height={buttonSize}
          width={buttonSize}
          fontSize={fontSize}
          left={leftPosition}
          top={topPosition}
          onClick={clickDelete}
        >
          {getIcon("exit")}
        </CloseButton>
      )}
      {children}
    </div>
  );
};

export default Selectable;
